import React, { useState } from 'react';
import { EmptyLayout } from 'components/ant/layouts';
import { Cards } from 'components/ant/ui/Cards';
import { getListingsPageProps } from 'lib/getListingsPageProps';

const Page = ({ listings, vip, page }) => {
  const [li] = useState(listings);

  return (
    <EmptyLayout>
      <Cards listings={li} vip={vip} page={page} location='worldwide' />
    </EmptyLayout>
  );
};

export const getStaticProps = async (ctx) => ({
  props: await getListingsPageProps({
    locale: ctx.locale,
    location: 'worldwide',
    page: 1,
  }),
  revalidate: 60,
});

export default Page;
